export default __webpack_public_path__ + "static/list-block-1-bg-phone-b75f7b72da5e655dd95855402329933e.png";